import { useEffect } from "react";
import { ReactSortable } from "react-sortablejs";
import Select from "../../../../commonComponents/Select/Select";

const ExclusionSelector = ({
  exclusionData,
  inputs,
  inputHandler,
  errors,
  formPlug,
  handleInputDelete,
  sortedExclusions,
  setSortedExclusions,
}) => {
  useEffect(() => {
    if (!inputs.exclusions || inputs.exclusions.length === 0) {
      setSortedExclusions([]);
      return;
    }
    setSortedExclusions((prevSorted) => {
      const prevIds = new Set(prevSorted.map((item) => item._id));
      const newIds = new Set(inputs.exclusions.map((item) => item._id));
      const ordered = prevSorted.filter((item) => newIds.has(item._id));
      const newItems = inputs.exclusions.filter(
        (item) => !prevIds.has(item._id)
      );
      return [...ordered, ...newItems];
    });
  }, [inputs.exclusions]);

  return (
    console.log(sortedExclusions),
    (
      <div className="row">
        <div className="col-12 col-md-6">
          <Select
            title="Choose Exclusion"
            className="css-slc-esc1"
            placeholder={"Select"}
            options={exclusionData}
            labelSetter={(o) => o?.exclusion_name}
            valueSetter={(option) => option._id}
            field={"exclusions"}
            error={errors.exclusions}
            value={inputs.exclusions ? inputs.exclusions : []}
            onChange={inputHandler}
            inputSocket={formPlug}
            Multi2
          />
        </div>
        <div className="row">
          {
            sortedExclusions?.length != 0?
            <ReactSortable
            list={sortedExclusions.map((item) => ({ ...item }))}
            setList={setSortedExclusions}
            animation={200}
            delayOnTouchStart
            delay={2}
            className="selectedIllusionListData"
            key={sortedExclusions?.[0]?._id}
          >
            {sortedExclusions.map((option) => (
              <div
                key={option._id}
                data-id={option._id}
                className="mb-1 draggable-item"
              >
                <div className="d-inline-block mb-1">
                  <button className="selected__item" type="button">
                    {option.exclusion_name}
                    <img
                      src="/assets/img/icons/close-red.svg"
                      onClick={() =>
                        handleInputDelete(option._id, "exclusions")
                      }
                      alt=""
                    />
                  </button>
                </div>
              </div>
            ))}
          </ReactSortable> : ''

          }
         
        </div>
      </div>
    )
  );
};

export default ExclusionSelector;
